// office-ui-fabric-react@6.210.6
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
import { setVersion } from '@uifabric/set-version';
setVersion('office-ui-fabric-react', '6.210.6');
//# sourceMappingURL=version.js.map